import { Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Home } from 'lucide-react';

export default function NotFoundPage() {
  const { isAuthenticated } = useAuth();
  const homePath = isAuthenticated ? '/home' : '/login';

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <p className="font-['Oswald'] text-7xl font-bold text-primary mb-4">404</p>
        <h1 className="font-['Oswald'] text-xl font-bold uppercase tracking-wider mb-2">
          Seite nicht gefunden
        </h1>
        <p className="text-sm text-muted-foreground mb-8">
          Die aufgerufene Seite existiert nicht oder wurde verschoben.
        </p>
        <Link
          to={homePath}
          className="inline-flex items-center gap-2 px-6 py-3 bg-primary text-primary-foreground uppercase tracking-wider font-bold text-sm hover:bg-primary/90 transition-colors"
        >
          <Home size={18} />
          Zur Startseite
        </Link>
      </div>
    </div>
  );
}
